import { FC } from "react";
import { TouchableOpacity, View, Text } from "react-native";
import CheckIcon from "@/assets/icons/main/checkIcon.svg";

interface ICustomCheckboxProps {
  label: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
  className?: string;
}

const checkboxClass: string = "w-5 h-5 mr-2 rounded border border-gray-400 items-center justify-center";

const CustomCheckbox: FC<ICustomCheckboxProps> = ({
  label,
  value,
  onChange,
  className = "",
}: ICustomCheckboxProps) => {
  return (
    <TouchableOpacity
      className={`flex-row items-center ${className}`}
      onPress={() => onChange(!value)}
      activeOpacity={0.8}
    >
      <View className={`${checkboxClass} ${value ? "bg-blue" : "bg-white"}`}>
        {value && <CheckIcon />}
      </View>
      <Text className="text-base">{label}</Text>
    </TouchableOpacity>
  );
}

export default CustomCheckbox;
